import { Component, Input, OnInit } from '@angular/core'
import { SharedService } from '../../../@core/services/shared.service'
import { ITurnColumn } from '../../../@core/services/working.service'
import _ from 'lodash'

@Component({
    templateUrl: './turn-order.component.html',
    styleUrls: ['./turn-order.component.scss'],
    selector: 'app-turn-order',
})
export class TurnOrderComponent implements OnInit {
    orderedData: Array<ITurnColumn>
    private _data: Array<ITurnColumn>
    @Input() set data(value: Array<ITurnColumn>) {
        this._data = value || []
        this.orderedData = _.sortBy(this._data, ['turnCnt', 'orderNo'])
    }
    get data(): Array<ITurnColumn> {
        return this._data
    }

    constructor(public sharedService: SharedService) {}

    ngOnInit() {}
}
